import { ActionTypes } from '../actions';

const { SET_MONETATE_EXPERIENCES } = ActionTypes;

const INITIAL_STATE = {
  monetateExperiences: [],
};

const experienceReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_MONETATE_EXPERIENCES:
      return {
        ...state,
        monetateExperiences: payload.experiences,
      };

    default:
      return state;
  }
};

export { INITIAL_STATE, experienceReducer };
